import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleGoals() {
    const drawer = document.querySelector("#goals-drawer [data-controller='drawer']")
    if (drawer) {
      const drawerCtrl = this.application.getControllerForElementAndIdentifier(drawer, "drawer")
      if (drawerCtrl) drawerCtrl.toggle()
    }
  }
}
